import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { DrawerBodyWrapper, Input, TOAST_TYPE } from '@base'
import { ActionButton, FormItemWrapper } from '../WeightCalculator/styles'
import { strings } from '@constants'
import { Spacings } from '@styles'
import { fetchFromProbe42 } from '@data'
import { showLoader, showToast } from '@data/state/action'

const FormWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	justify-content: end;
	margin-top: ${Spacings.SPACING_3B};
`

const FetchFromProbeTool = () => {
	const dispatch = useDispatch()
	const [pan, setPan] = useState('')

	const onPanChange = (value) => {
		setPan(value)
	}

	const submitHandler = () => {
		dispatch(showLoader(true))
		fetchFromProbe42(pan)
			.then(() => {
				dispatch(showToast(true, 'Probe data fetched successfully', { type: TOAST_TYPE.SUCCESS }))
			})
			.catch((error) => {
				let error_msg = error?.response?.data?.message || 'Some error occurred, data not fetcehd.'
				dispatch(showToast(true, error_msg, { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}

	const isDisabled = () => {
		let panRegex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/
		let gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
		if (panRegex.test(pan) || gstRegex.test(pan)) {
			return false
		}
		return true
	}
	return (
		<DrawerBodyWrapper>
			<>
				<FormItemWrapper>
					<Input
						pattern='[A-Z]{5}[0-9]{4}[A-Z]{1}'
						placeholder='Enter PAN'
						label='Organisation Pan'
						type='text'
						value={pan}
						maxLength='10'
						errorMap={{
							patternMismatch: strings('enter_valid_pan'),
							valueMissing: strings('pan_required'),
						}}
						uppercase
						onChange={onPanChange}
					/>
					<FormWrapper>
						<ActionButton small type='primary' disabled={isDisabled()} onClick={submitHandler}>
							{strings('submit')}
						</ActionButton>
					</FormWrapper>
				</FormItemWrapper>
			</>
		</DrawerBodyWrapper>
	)
}

export default FetchFromProbeTool
